/**
 * usePayment Hook
 *
 * Access the payment/entitlement context from any authed component.
 * Must be used within a PaymentProvider (mounted in AppShell).
 */

import { useContext } from 'react'
import { PaymentContext } from '@/contexts/PaymentContext'

export function usePayment() {
  return useContext(PaymentContext)
}
